<div class="breadcrumbs">
  <span class="title">Gestione Emergenze <mat-icon style="vertical-align: middle;">keyboard_arrow_right</mat-icon> Anagrafica Utenti </span>
</div>
<hr>
<div class="titolo flex-display">
  <span class="h1 upp">Anagrafica Utenti</span>
  <button mat-stroked-button color='basic' class="pers2" (click)="onNuovo()">
    NUOVO
  </button>
</div>


<mat-expansion-panel class='rett' hideToggle (opened)="arrowFlag = !arrowFlag" (closed)='arrowFlag = !arrowFlag'>
  <mat-expansion-panel-header class="colorSearch">
    <mat-panel-title class='search'>
      <mat-icon>search</mat-icon>
      <strong class="title">CERCA</strong>
      <mat-icon *ngIf="arrowFlag">keyboard_arrow_up</mat-icon>
      <mat-icon *ngIf="!arrowFlag">keyboard_arrow_down</mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="coloredS" [formGroup]="form">


    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Codice Fiscale</mat-label>
        <input matInput [formControlName]="'codiceFiscale'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Cognome</mat-label>
        <input matInput [formControlName]="'cognome'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Nome</mat-label>
        <input matInput [formControlName]="'nome'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Abilitato</mat-label>
        <mat-select [formControlName]="'associato'">
          <mat-option [value]="null"></mat-option>
          <mat-option [value]="true">Si</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

  </div>
  <mat-action-row class='colored'>
    <button mat-stroked-button class="pers2" color="warn" (click)="onReset()">Reset</button>
    <button mat-raised-button class="pers2" color="accent" (click)="ricercaUtenti()">Cerca</button>
  </mat-action-row>
</mat-expansion-panel>


<!-- ordinamento iniziale per cognome -->
<mat-table [dataSource]="dataSource" matSort matSortActive="cognome" matSortDirection="asc" matSortDisableClear>

  <ng-container matColumnDef="codiceFiscale">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Cod. Fisc. </mat-header-cell>
    <mat-cell [attr.data-label]="'COD. FISC.'" *matCellDef="let element"> {{element.codiceFiscale}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="cognome">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Cognome </mat-header-cell>
    <mat-cell [attr.data-label]="'COGNOME'" *matCellDef="let element"> {{element.cognome}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="nome">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
    <mat-cell [attr.data-label]="'NOME'" *matCellDef="let element"> {{element.nome}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="associazione">
    <mat-header-cell *matHeaderCellDef> Abilitato </mat-header-cell>
    <mat-cell [attr.data-label]="'ASSOCIAZIONE'" *matCellDef="let element">
      <span *ngIf="element.associato === true" class="material-icons green-icon">check_circle</span>
      <span *ngIf="element.associato === false" class="material-icons red-icon">cancel</span>
      <span *ngIf="element.associato === null" class="blank-icon"></span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="azioni">
    <mat-header-cell [ngClass]="'customWidthClass'" *matHeaderCellDef> Azioni </mat-header-cell>
    <mat-cell [ngClass]="'customWidthClass'" *matCellDef="let element; let i = index">
      <span *ngIf="i !== openToggle" class="material-icons tool" title="apri/chiudi toolbar"
        (click)="handleToolbarClick($event, i)">more_horiz</span>
      <myp-toolbar *ngIf="i === openToggle" [toolbar]="generateToolBar()" role=toolbar
        [data]="element" (onToolbarEvent)="handleToolbarEvent($event)">
      </myp-toolbar>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

</mat-table>


<div *ngIf="this.dataSource.counter$.source['value'] === 0">
  <mat-card class="emptyTable">
    <mat-card-content>
      <h6>Non ci sono risultati</h6>
    </mat-card-content>
  </mat-card>
</div>

<mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="risultatiPerPagina" [pageSizeOptions]="[3, 5, 10, 100, 300]"></mat-paginator>
